export const isPartnerExperience = () => process.env.REACT_APP_WR_USES_SSO === 'true'
